
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgotPassword",
      function () {
        return require("private-next-pages/forgotPassword/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgotPassword"])
      });
    }
  